import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  TemplateRef
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { ButtonModule } from 'primeng/button';
import { GetUserProfileCredentialsByEmailPipe } from '../user-credenionals-by-email.directive';

@Component({
  selector: 'app-note-template-container',
  templateUrl: './note-template-container.component.html',
  imports: [
    CommonModule,
    ButtonModule,
    GetUserProfileCredentialsByEmailPipe
  ]
})
export class NoteTemplateContainerComponent implements AfterViewInit {
  private readonly ref: ElementRef = inject(ElementRef);

  private _size!: string;

  @Input() cancelButtonLabel!: string;
  @Input() headerTemplate: TemplateRef<any> | undefined;
  @Input() isEditable: boolean = false;
  @Input() isExistingNote: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() isSaveButtonEnabled: boolean = true;
  @Input() noteDetail: any;
  @Input() product = this.mapProductNamesToProduct();
  @Input() saveButtonLabel!: string;
  @Input() showAuthor: boolean = false;

  @Input() showCancelButton: boolean = false;
  @Input() showSaveButton: boolean = false;

  @Input() template: TemplateRef<any> | undefined;
  @Input() saveEnable: boolean = true;

  @Input() get size(): string {
    return this._size;
  }
  set size(value: string) {
    this._size = value;
    this.emitSizeChangeEvent(value);
  }

  @Input() noteForm!: FormGroup;
  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveDraft: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveAddendum: EventEmitter<any> = new EventEmitter<any>();

  ngAfterViewInit() {
    this.emitSizeChangeEvent(this.size);
  }

  emitSizeChangeEvent(size: string = 'sm') {
    this.ref.nativeElement.dispatchEvent(
      new CustomEvent('noteTemplate.sizeChange', {
        bubbles: true,
        detail: { size: size }
      })
    );
  }

  getApiService(): ProductNames {
    if (window.location.href.includes('pac-im')) {
      return ProductNames.PACIM;
    }
    if (window.location.href.includes('pac-commercial')) {
      return ProductNames.PacCommercial;
    }
    if (window.location.href.includes('dmepos')) {
      return ProductNames.DMEPOS;
    }

    return ProductNames.HomeHealth;
  }

  mapProductNamesToProduct() {
    switch (this.getApiService()) {
      case ProductNames.DMEPOS:
        return 'DMEPOS';
      case ProductNames.PACIM:
      case ProductNames.PacCommercial:
        return 'PACIM';
      default:
        return 'HH';
    }
  }
}
